<template>
	<div>
		<!-- Ad Placement -->
		<div
			:class="`plc719238`"
			ref="adPlacement"
		></div>
	</div>
</template>

<script setup>
const adPlacement = ref();

onMounted(() => {
	// Check if AdButler is already defined to avoid re-inserting the script
	if (process.client) {
		if (!window.AdButler) {
			const script = document.createElement("script");
			script.async = true;
			script.type = "text/javascript";
			script.src = "https://servedbyadbutler.com/app.js";
			adPlacement.value.parentElement.prepend(script);
			// await setTimeout(initializeAdButler, 250);
			initializeAdButler();
		} else {
			// Directly initialize AdButler if the script is already present
			initializeAdButler();
		}
	}
});

const initializeAdButler = () => {
	const script = document.createElement("script");
	const adButlerScript = `
	var AdButler = AdButler || {}; AdButler.ads = AdButler.ads || [];
var abkw = window.abkw || '';
var plc719238 = window.plc719238 || 0;
(function(){
var divs = document.querySelectorAll(".plc719238:not([id])");
var div = divs[divs.length-1];
div.setAttribute("id", "placement_719238_"+plc719238);
AdButler.ads.push({handler: function(opt){ AdButler.register(181458, 719238, [0,0], 'placement_719238_'+opt.place, opt); }, opt: { place: plc719238++, keywords: abkw, domain: 'servedbyadbutler.com', click: 'CLICK_MACRO_PLACEHOLDER' }});
})();`;

	script.innerHTML = adButlerScript;
	adPlacement.value.parentNode.appendChild(script);
};
</script>
